import { Editor } from "grapesjs";
import { AI_ICON_SVG } from "features/lightningLanders/constants";
import { GRID_CONFIG_ATTR } from "features/lightningLanders/utils/dynamicBlockGrid";

const emailFn = async function (event: Event) {
  event.preventDefault();
  const form = event.target as HTMLFormElement;
  const foundAlert = form.querySelector("#inc-form-alert");
  if (foundAlert) {
    foundAlert.remove();
  }

  const submitButton = form.querySelector(
    'button[type="submit"]',
  ) as HTMLButtonElement;
  if (submitButton) {
    submitButton.disabled = true;
  }
  // error by default
  const alert = document.createElement("div");
  alert.id = "inc-form-alert";
  alert.style.marginTop = "5px";
  alert.style.padding = "3px 5px";
  alert.style.border = "2px solid #D54747";
  alert.style.borderRadius = "10px";
  alert.style.background = "#d54747c2";
  alert.style.color = "#fff";
  alert.className = "error";
  alert.innerHTML = "Internal Error - Please try again";

  try {
    const formData = new FormData(form);
    const body = JSON.stringify(Object.fromEntries(formData.entries()));
    // @ts-ignore
    await window.inc("event_sent_email", {
      to: form.getAttribute("data-inc-to"),
      body,
    });

    alert.style.border = "2px solid #008D16";
    alert.style.background = "#008d16c4";
    alert.className = "success";
    alert.innerHTML = "Success - Message Sent";
  } catch (error) {
    console.error(error);
  }
  form.appendChild(alert);
  if (submitButton) {
    submitButton.disabled = false;
  }
  return false;
};

const emailFnText = `return (${emailFn})(event);`;

export function registerLightningLandersCustomBlocks(editor: Editor) {
  // Add Section block to Basic category
  editor.BlockManager.add("section-block", {
    label: "Section",
    category: "Basic",
    // attributes: { class: "fa fa-th-large" },
    media: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="2" y="6" width="20" height="14" fill="rgba(255,255,255,0.9)" />
      <rect x="4" y="8" width="16" height="10" fill="currentColor" />
    </svg>`,
    content: {
      tagName: "section",
      classes: ["inc-section"],
      attributes: { "data-gjs-type": "inc-section" },
      style: {
        display: "flex",
        padding: "40px",
      },
      draggable: true,
      droppable: true,
      components: [
        {
          type: "container",
          tagName: "div",
          classes: ["inc-container"],
          attributes: { "data-gjs-type": "inc-container" },
          style: {
            margin: "0 auto",
            "max-width": "var(--container-width, 1200px)",
            width: "100%",
          },
          droppable: true,
        },
      ],
    },
    // order: 1,
  });

  // Dynamic product grid section, recognize by data attribute so we can show edit toolbar
  editor.DomComponents.addType("inc-dynamic-product-grid", {
    extend: "section",
    isComponent: (el) =>
      el?.tagName === "SECTION" && el.getAttribute?.(GRID_CONFIG_ATTR) != null,
    model: {
      defaults: {
        type: "inc-dynamic-product-grid",
        tagName: "section",
        draggable: true,
        droppable: true,
        toolbar: [
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z"/></svg>`,
            command: "select-parent",
            attributes: { title: "Select parent" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z"/></svg>`,
            command: "tlb-move",
            attributes: { title: "Move" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"/></svg>`,
            command: "tlb-clone",
            attributes: { title: "Clone" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"/></svg>`,
            command: "tlb-delete",
            attributes: { title: "Delete" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>`,
            command: "open-settings",
            attributes: { title: "Settings" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"/></svg>`,
            command: "open-dynamic-grid-settings",
            attributes: { title: "Edit grid settings" },
          },
        ],
      },
    },
  });

  // Add a custom section component
  editor.DomComponents.addType("section", {
    model: {
      defaults: {
        type: "section",
        tagName: "section",
        draggable: true,
        droppable: true,
        attributes: { class: "inc-section", "data-gjs-type": "inc-section" },
        resizable: {
          ratioDefault: true,
        },
        traits: [
          {
            type: "text",
            label: "ID",
            name: "id",
            changeProp: true,
          },
          {
            type: "text",
            label: "Class",
            name: "class",
            changeProp: true,
          },
        ],
        styles: {
          display: "flex",
          padding: "50px 0",
        },
      },
    },
  });

  // Add a custom container component
  editor.DomComponents.addType("container", {
    model: {
      defaults: {
        tagName: "div",
        draggable: true,
        droppable: true,
        attributes: {
          class: "inc-container",
          "data-gjs-type": "inc-container",
        },
        resizable: {
          ratioDefault: true,
        },
        styles: {
          width: "90%",
          margin: "0 auto",
          "max-width": "var(--container-width, 1200px)",
        },
      },
    },
  });

  // Add Headings block to Basic category
  editor.BlockManager.add("headings-block", {
    label: "Headings",
    category: "Basic",
    attributes: { class: "fa fa-header" },
    media: `<svg  viewBox="0 0 24 24"><text x="3" y="21" font-size="23" font-family="Arial">H</text></svg>`,
    content: {
      type: "heading",
      tagName: "h1",
      content: "Heading",
      attributes: { "data-gjs-type": "heading" },
    },
    // order: 2,
  });

  // Add custom heading component type
  editor.DomComponents.addType("heading", {
    extend: "text",
    // This function tells GrapesJS to recognize h1-h6 tags as heading components
    isComponent: (el) => {
      if (el && ["H1", "H2", "H3", "H4", "H5", "H6"].includes(el.tagName)) {
        return { type: "heading" };
      }
      return false;
    },
    model: {
      defaults: {
        tagName: "h1",
        traits: [
          {
            type: "select",
            label: "Heading Type",
            name: "tagName",
            options: [
              { id: "h1", name: "H1" },
              { id: "h2", name: "H2" },
              { id: "h3", name: "H3" },
              { id: "h4", name: "H4" },
              { id: "h5", name: "H5" },
              { id: "h6", name: "H6" },
            ],
            changeProp: true,
          },
        ],
      },
      // Add explicit 'this: any' type annotation to fix TS error
      init(this: any) {
        this.listenTo(this, "change:tagName", function (this: any) {
          const tag = this.get("tagName");
          if (tag) {
            this.set("tagName", tag);
          }
        });
      },
    },
    view: {},
  });

  editor.DomComponents.addType("video", {
    extend: "video",
    // This function tells GrapesJS to recognize <video> tags as video components
    isComponent: (el) => {
      if (el && el.tagName === "VIDEO") {
        return { type: "video" };
      }
      return false;
    },
    model: {
      defaults: {
        toolbar: [
          // these are the default toolbar elements
          {
            // attributes: { class: 'fa fa-arrow-up' },
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z"></path></svg>`,
            command: "select-parent",
          },
          {
            // attributes: { class: 'fa fa-arrows' },
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z"></path></svg>`,
            command: "tlb-move",
          },
          {
            // attributes: { class: 'fa fa-clone' },
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"></path></svg>`,
            command: "tlb-clone",
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path></svg>`,
            // attributes: { class: 'fa fa-trash' },
            command: "tlb-delete",
          },
          // open settings
          {
            label: `<svg viewBox="0 0 24 24" ><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"></path></svg>`,
            // attributes: { class: "fa fa-cog" },
            command: "open-settings",
          },
          // save as block
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"/></svg>`,
            command: "save-as-block",
            attributes: { title: "Save as Block" },
          },
        ],
      },
    },
  });

  editor.DomComponents.addType("image", {
    extend: "image",
    // This function tells GrapesJS to recognize <img> tags as image components
    isComponent: (el) => {
      if (el && el.tagName === "IMG") {
        return { type: "image" };
      }
      return false;
    },
    model: {
      defaults: {
        toolbar: [
          // these are the default toolbar elements
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z"></path></svg>`,
            command: "select-parent",
            attributes: { title: "Select parent" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z"></path></svg>`,
            command: "tlb-move",
            attributes: { title: "Move" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"></path></svg>`,
            command: "tlb-clone",
            attributes: { title: "Clone" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path></svg>`,
            command: "tlb-delete",
            attributes: { title: "Delete" },
          },
          {
            label: `<svg viewBox="0 0 24 24" ><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0 -.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"></path></svg>`,
            command: "open-settings",
            attributes: { title: "Settings" },
          },
          {
            label: `<svg viewBox="0 0 24 24" ><path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8zM5 19l3-4 2 3 3-4 4 5z"></path></svg>`,
            command: "edit-assets",
            attributes: { title: "Change image" },
          },
          {
            label: AI_ICON_SVG,
            command: "open-ai-edit-image",
            attributes: { title: "Edit with AI" },
          },
          // save as block
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"/></svg>`,
            command: "save-as-block",
            attributes: { title: "Save as Block" },
          },
        ],
      },
    },
  });

  const aiImagePlaceholderSrc =
    "data:image/svg+xml," +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200"><rect fill="#e4e6f8" width="200" height="200"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#666" font-family="sans-serif" font-size="14">AI Image</text></svg>',
    );
  editor.BlockManager.add("ai-image", {
    label: "AI Image",
    category: "Basic",
    media: AI_ICON_SVG,
    content: {
      type: "image",
      attributes: {
        "data-ai-image": "true",
        src: aiImagePlaceholderSrc,
      },
      style: { width: "200px", height: "200px" },
    },
  });

  // Add Grid component type
  editor.DomComponents.addType("grid", {
    model: {
      defaults: {
        tagName: "div",
        draggable: true,
        droppable: true,
        attributes: { class: "inc-grid", "data-gjs-type": "grid" },
        selectorsAdd: ".inc-grid",
        traits: [
          {
            type: "select",
            label: "Columns",
            name: "columns",
            options: Array.from({ length: 12 }, (_, i) => ({
              id: String(i + 1),
              name: `${i + 1} Column${i > 0 ? "s" : ""} `,
            })),
            default: "2",
            changeProp: true,
          },
        ],
      },
      init(this: any) {
        this.listenTo(this, "change:columns", function (this: any) {
          const columns = Number(this.get("columns"));
          const components = this.components();

          // Remove excess columns
          while (components.length > columns) {
            components.pop();
          }

          // Add new columns if needed
          while (components.length < columns) {
            const defaultWidth = Math.floor(12 / columns);
            components.add({
              type: "grid-cell",
              components: [],
              attributes: { class: `inc-sm-col-12 inc-md-col-${defaultWidth}` },
            });
          }

          // Update column widths to be equal
          components.each((cell: any, index: number) => {
            const width = Math.floor(12 / columns);
            cell.setAttributes({ class: `inc-sm-col-12 inc-md-col-${width}` });
          });
        });
      },
    },
  });

  // Add Grid Cell component type
  editor.DomComponents.addType("grid-cell", {
    model: {
      defaults: {
        tagName: "div",
        attributes: { class: "inc-grid-cell", "data-gjs-type": "grid-cell" },
        draggable: true,
        droppable: true,
        resizable: {
          handles: "e",
          tc: false,
          cl: false,
          cr: true,
          bc: false,
          bl: false,
          br: false,
          tl: false,
          tr: false,
          minDim: 50,
          maxDim: 1000,
          currentUnit: 0,
          step: 2,
          keyWidth: "width",
          keyHeight: "height",
          onStart: function () {
            const component = editor.getSelected();
            if (!component) return;
            const cell = component.getEl();
            const grid = cell?.parentElement;
            if (!grid) return;
            const cells = Array.from(grid.children);
            const cellIndex = cells.indexOf(cell);
            // Add .locked to all cells to the left
            for (let i = 0; i < cellIndex; i++) {
              cells[i].classList.add("locked");
            }
          },
          onMove: function () {
            return false;
          },
          onEnd: async function () {
            const component = editor.getSelected();
            if (!component) return false;
            const cell = component.getEl();
            const grid = cell?.parentElement;
            if (!grid) return false;

            // Remove .locked from all cells
            const cells = Array.from(grid.children);
            cells.forEach((c) => (c as HTMLElement).classList.remove("locked"));

            const gridWidth = grid.offsetWidth;
            const pointsPerPixel = 12 / gridWidth;
            const cellWidth = cell.offsetWidth;
            const clampedSize = Math.max(
              1,
              Math.min(12, Math.round(cellWidth * pointsPerPixel)),
            );

            component.setClass(`inc-sm-col-12 inc-md-col-${clampedSize}`);
            const cssRule = component._getStyleRule();
            if (cssRule) cssRule.setStyle({ width: "" });

            const cellIndex = cells.indexOf(cell);

            // Sum the sizes of all cells to the left
            let leftSize = 0;
            for (let i = 0; i < cellIndex; i++) {
              const leftCell = cells[i] as HTMLElement;
              const leftComponent = editor
                .getWrapper()
                ?.find(`#${leftCell.id} `)[0];
              if (leftComponent) {
                const leftClass = leftComponent
                  .getClasses()
                  .find((cls) => cls.startsWith("inc-md-col-"));
                if (leftClass) {
                  const size = parseInt(
                    leftClass.replace("inc-md-col-", ""),
                    10,
                  );
                  if (!isNaN(size)) leftSize += size;
                }
              }
            }

            // Calculate remaining size for right cells
            let remainingSize = 12 - clampedSize - leftSize;
            const rightCells = cells.slice(cellIndex + 1);

            if (rightCells.length > 0) {
              const baseSize = Math.floor(remainingSize / rightCells.length);
              const extraSize = remainingSize % rightCells.length;

              rightCells.forEach((otherCell, idx) => {
                const otherComponent = editor
                  .getWrapper()
                  ?.find(`#${otherCell.id} `)[0];
                if (otherComponent) {
                  const cellSize = baseSize + (idx < extraSize ? 1 : 0);
                  otherComponent.setClass(
                    `inc-sm-col-12 inc-md-col-${cellSize}`,
                  );
                  const otherCssRule = otherComponent._getStyleRule();
                  if (otherCssRule) otherCssRule.setStyle({ width: "" });
                }
              });
            }

            return false;
          },
        },
        styles: {
          "min-height": "50px",
          padding: "10px",
        },
      },
    },
  });

  // Add Grid blocks to new Grid category
  editor.BlockManager.add("grid-2-columns", {
    label: "2 Columns",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-6" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-6" },
        },
      ],
    },
    media: `<svg viewBox = "0 0 23 24" ><path fill="currentColor" d = "M2 20h8V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM13 20h8V4h-8v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Z" > </path></svg>`,
  });

  editor.BlockManager.add("grid-3-columns", {
    label: "3 Columns",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-4" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-4" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-4" },
        },
      ],
    },
    media: `<svg viewBox="0 0 23 24">
        <path fill="currentColor" d="M2 20h4V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM17 20h4V4h-4v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1ZM9.5 20h4V4h-4v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  editor.BlockManager.add("grid-4-columns", {
    label: "4 Columns",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
      ],
    },
    media: `<svg viewBox="0 0 24 24">
         <path fill="currentColor" d="M2 20h4V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM7 20h4V4H7v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1ZM12 20h4V4h-4v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1ZM17 20h5V4h-5v16Zm-1 0V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  editor.BlockManager.add("grid-2-3-7", {
    label: "2 Columns (3/7)",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-9" },
        },
      ],
    },
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h5V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM10 20h12V4H10v16Zm-1 0V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  editor.BlockManager.add("grid-2-7-3", {
    label: "2 Columns (7/3)",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-9" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
      ],
    },
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h12V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM17 20h5V4h-5v16Zm-1 0V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  editor.BlockManager.add("grid-2-4-8", {
    label: "2 Columns (4/8)",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-4" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-8" },
        },
      ],
    },
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h6V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM11 20h11V4H11v16Zm-1 0V4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  editor.BlockManager.add("grid-2-8-4", {
    label: "2 Columns (8/4)",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-8" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-4" },
        },
      ],
    },
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h11V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM16 20h6V4h-6v16Zm-1 0V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  editor.BlockManager.add("grid-3-3-6", {
    label: "3 Columns (3/3/6)",
    category: "Grid",
    attributes: { "data-gjs-type": "grid" },
    content: {
      type: "grid",
      components: [
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-3" },
        },
        {
          type: "grid-cell",
          components: [],
          attributes: { class: "inc-sm-col-12 inc-md-col-6" },
        },
      ],
    },
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h4V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM8 20h4V4H8v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1ZM14 20h8V4h-8v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Z"></path>
      </svg>`,
  });

  // Add Box/div wrapper block to Basic category
  editor.BlockManager.add("box-block", {
    label: "Div / Box",
    category: "Basic",
    attributes: { "data-gjs-type": "box" },
    media: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"/>
      <rect x="6" y="6" width="12" height="12" fill="rgba(255,255,255,0.1)"/>
    </svg>`,
    content: {
      type: "box",
      tagName: "div",
      classes: ["inc-box"],
      draggable: true,
      droppable: true,
      components: [],
    },
  });

  // Add custom box component type
  editor.DomComponents.addType("box", {
    model: {
      defaults: {
        tagName: "div",
        draggable: true,
        droppable: true,
        attributes: { class: "inc-box", "data-gjs-type": "box" },
        resizable: {
          ratioDefault: true,
        },
      },
    },
  });

  // Override grapesjs-plugin-forms button so HTML-parsed buttons keep their text.
  // The plugin's init overwrites content with default "Send" when the text node
  // isn't in components list yet; we only overwrite when the button has no children so if added by html editor or ai it should not be effected.
  editor.DomComponents.addType("button", {
    extend: "button",
    model: {
      init(this: any) {
        const comps = this.components();
        const single = comps.length === 1 ? comps.models[0] : null;
        const contentFromChild =
          (single && single.is?.("textnode") && single.get("content")) || "";
        const defaultText = this.get("text") ?? "Send";
        const textToUse =
          contentFromChild || (comps.length === 0 ? defaultText : "");
        this.set("text", textToUse);
        this.on("change:text", this.__onTextChange);
        if (textToUse !== contentFromChild && comps.length === 0) {
          this.__onTextChange();
        }
      },
    },
  });

  // Extend form component to add onSubmit and styling options
  // Store reference to original form type before extending
  const originalFormType = editor.DomComponents.getType("form");
  const originalFormDefaults = originalFormType?.model.prototype.defaults || {};
  const originalFormTraits = originalFormDefaults.traits || [];

  editor.DomComponents.addType("form", {
    extend: "form",
    model: {
      defaults: {
        // Get parent defaults and merge our custom traits
        ...originalFormDefaults,
        // Add padding so empty form is selectable
        styles: {
          padding: "20px",
          "min-height": "50px",
          ...(originalFormDefaults.styles || {}),
        },
        components: [],
        traits: [
          {
            name: "onsubmit",
            type: "select",
            label: "On Submit",
            options: [
              {
                id: "email-details",
                name: "Email Details",
                value: emailFnText,
              },
            ],
          },
          {
            name: "data-inc-to",
            label: "Email Address",
          },
          // Spread existing form traits (action, method, enctype, etc.) after our custom ones
          ...originalFormTraits.filter(
            (t: any) => t.name !== "onsubmit" && t.name !== "data-inc-to",
          ),
        ],
      },
      init(this: any) {
        // Ensure padding and min-height are set for empty form selectability
        const currentStyles = this.getStyle();
        if (!currentStyles.padding && !currentStyles["min-height"]) {
          this.addStyle({
            padding: "20px",
            "min-height": "50px",
          });
        } else {
          // Ensure both are set even if one exists
          if (!currentStyles.padding) {
            this.addStyle({ padding: "20px" });
          }
          if (!currentStyles["min-height"]) {
            this.addStyle({ "min-height": "50px" });
          }
        }

        // Add "blank" option to method trait if it exists
        const methodTrait = this.getTrait("method");
        if (methodTrait) {
          const hasBlankMethod = methodTrait.getOption("blank");
          if (!hasBlankMethod) {
            methodTrait.set("options", [
              { id: "blank", value: "", name: "blank" },
              ...methodTrait.getOptions(),
            ]);
          }
        }
      },
    },
  });

  // Add save-as-block button to default component toolbar
  const defaultType = editor.DomComponents.getType("default");
  const defaultModel = defaultType.model;
  const defaultToolbar = defaultModel.prototype.defaults.toolbar;

  // Extend the default toolbar for all components that don't have a custom one
  editor.DomComponents.addType("default", {
    model: {
      defaults: {
        toolbar: [
          ...(defaultToolbar || []),
          {
            label: AI_ICON_SVG,
            command: "open-ai-edit",
            attributes: { title: "Edit with AI" },
          },
          {
            label: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"/></svg>`,
            command: "save-as-block",
            attributes: { title: "Save as Block" },
          },
        ],
      },
    },
  });
}
